import { errorGeneric, errorOccurred, errorPermission } from "_constants";

import { useSnackbar } from "providers/SnackbarProvider";

export const useSnackbarMessages = () => {
  const { showSnackbar } = useSnackbar();

  const showDialogError = () => {
    showSnackbar({
      severity: "error",
      summary: errorOccurred,
      detail: errorGeneric,
      life: 5000,
    });
  };

  const showDialogForbidden = () => {
    showSnackbar({
      severity: "error",
      summary: errorOccurred,
      detail: errorPermission,
      life: 5000,
    });
  };

  return { showDialogError, showDialogForbidden };
};
